import DocumentDrawer from "pages/Projects/EditProject/Drawer/DocumentDrawer"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import { changeNavbarParams, loadPageItem } from "store/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import download from "downloadjs"

const ManageDocuments = props => {
  const scenarioId = props.match.params.scenarioId
  const currentUser = userService.getLoggedInUser()
  const dispatch = useDispatch()
  const { pageItem } = useSelector(state => ({
    pageItem: state.pageItem.pageItem,
  }))
  const [alternative, setAlternative] = useState({
    alternativeID: 0,
    scenarioID: scenarioId,
  })
  const [alternatives, setAlternatives] = useState([])
  const [activeDrawer, setActiveDrawer] = useState("")

  useEffect(() => {
    dispatch(
      loadPageItem({
        userId: currentUser.userID,
        scenarioId: props.match.params.scenarioId,
        alternativeId: 0,
        viewName: "manageDocuments",
      })
    )
    dispatch(
      changeNavbarParams({
        userId: currentUser.userID,
        scenarioId: props.match.params.scenarioId,
        viewName: "manageDocuments",
      })
    )
    loadData()
  }, [])

  const loadData = async () => {
    // let alts = await api.getAlternatives(currentUser.userID, scenarioId)
    // setAlternatives(alts)
    setAlternative({ alternativeID: 0, scenarioID: scenarioId })
    setActiveDrawer("Document")
  }

  const dld = () => {
    api.getPowerPointDocument(1).then(blob => {
      download(blob, "example.pptx")
      setIsLoading(false)
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={pageItem !== undefined ? pageItem.pageSubTitle : ""}
          />
          {/* <button onClick={dld}>asdasd</button> */}
          <Row>
            <Col>
              <Card>
                <CardBody>
                  {alternative != null && (
                    <DocumentDrawer
                      activeDrawer={activeDrawer}
                      alternative={alternative}
                      renderAsTable={true}
                      alternatives={alternatives}
                      props={props}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ManageDocuments
